import * as React from 'react';
import Snackbar, { } from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Container } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setShowAlert } from 'src/state/utilts/utilsSlice';

export interface SnackbarMessage {
    message: string;
    key: number;
}

export interface State {
    open: boolean;
    snackPack: readonly SnackbarMessage[];
    messageInfo?: SnackbarMessage;
}

interface Props {
    typeVariant?: any;
    type?: any;
    showAlert?: boolean;
    message?: string;
}

const AlertBox = ({ typeVariant = 'filled', type = 'error', showAlert = false, message = '' }: Props) => {

    const dispatch = useDispatch();

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        dispatch(setShowAlert({ show: false, message: '', type: '' }))
    };

    return (
        <Container sx={{ zIndex: 99 }} >
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={showAlert}
                autoHideDuration={1500}
                onClose={handleClose}
                sx={{ mt: 5 }}
            >
                {message ? <Alert variant={typeVariant} severity={type} action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={() => dispatch(setShowAlert({ show: false, message: '', type: '' }))}
                    >
                        <CloseIcon />
                    </IconButton>
                }>
                    {message}
                </Alert> : null}
            </Snackbar>
        </Container>
    );
}
export default AlertBox;